import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { useAuth } from '../../auth/context/AuthContext';
import { shouldRightAlignProperty } from '../../utils/shouldRightAlignProperty';
import { isDateTime } from 'customer-data-objects/property/PropertyIdentifier';
import TruncateDiv from '../TruncateDiv';
const FLEX_ASSOCIATIONS_GATE = 'flexible-associations';

const PropertyHeaderContent = ({
  propertyDefinition
}) => {
  const {
    hasGate
  } = useAuth();
  const content = useMemo(() => {
    if (propertyDefinition.name === 'associatedcompanyid') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: hasGate(FLEX_ASSOCIATIONS_GATE) ? 'datatable.associatedCompanyId.flexibleAssociationsHeader' : 'datatable.associatedCompanyId.standardHeader'
      });
    }

    if (isDateTime(propertyDefinition)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.dateTimeCell.header",
        options: {
          label: propertyDefinition.label,
          timezone: I18n.moment.userTz().format('z')
        }
      });
    }

    return propertyDefinition.label;
  }, [hasGate, propertyDefinition]);
  return /*#__PURE__*/_jsx(TruncateDiv, {
    rightAligned: shouldRightAlignProperty(propertyDefinition),
    children: content
  });
};

export default PropertyHeaderContent;